import { Box } from "@similarweb/ui-components";
import styled, { css } from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { Title } from "@similarweb/ui-components";
import { mixins } from "@similarweb/styles";
import StyledBoxSubtitle from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";

const AddToDashboardWrapper = styled.div`
    position: absolute;
    top: 3px;
    right: 2px;
    @media (max-width: 1365px) {
        top: 11px;
        right: 9px;
    }
`;

const StyledBox = styled(Box)<{
    height: number;
    marginRight?: number;
}>`
    height: ${({ height }) => height}px;
    display: flex;
    flex-direction: column;
    ${({ marginRight }) =>
        marginRight &&
        css`
            margin-right: ${marginRight}px;
        `};
`;

const TitleContainer = styled.div`
    padding: 24px 17px 30px 24px;
    position: relative;
`;

const CtaWrapper = styled.div<{ marginTop: number }>`
    padding-right: 15px;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    margin-top: ${({ marginTop }) => marginTop + "px"};
    height: 51px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const StyledHeaderTitle = styled(Title).attrs<{ "data-automation-box-title"?: boolean }>((props) => ({
    "data-automation-box-title": true,
}))`
    font-size: 20px;
    ${InfoIcon} {
        line-height: 1.55;
    }
`;

export const StyledSubtitle = styled(BoxSubtitle)`
    font-size: 13px;
`;

export const SubTitleWrapper = styled(StyledBoxSubtitle)`
    margin-top: 6px;
    ${mixins.setFont({ $size: 14 })}
`;
